<script setup lang="ts">
import { TuButton } from "@tinyurldev/tu-ui-vue";

import useTranslation from "@Resources/js/composables/useTranslation";

//
// Setup
const { __ } = useTranslation();

//
// Emit
interface Events {
  (e: "retry"): void;
}

const emit = defineEmits<Events>();
</script>

<template>
  <div class="error-overlay">
    <i class="error-overlay__icon fa-solid fa-triangle-exclamation" />
    <h5 class="error-overlay__title">
      {{ __("organization_dashboard.error_overlay.title") }}
    </h5>
    <p class="error-overlay__message">
      {{ __("organization_dashboard.error_overlay.message") }}
    </p>
    <TuButton
      class="_retry"
      icon-class="fa-solid fa-arrows-rotate"
      :label="__('organization_dashboard.error_overlay.button_label')"
      is-outlined
      @click="emit('retry')"
    />
  </div>
</template>

<style lang="scss" scoped>
@use "@tinyurldev/tu-ui-vue/scss/settings/typography.scss" as typography;
@use "@tinyurldev/tu-ui-vue/scss/settings/position.scss" as position;
@use "@tinyurldev/tu-ui-vue/scss/settings/spacing.scss" as spacing;
@use "@tinyurldev/tu-ui-vue/scss/settings/colors.scss" as color;

.error-overlay {
  display: flex;
  flex-flow: column;
  gap: spacing.$xxs;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  background-color: color.$background-primary;

  &__icon {
    color: color.$alert;
    font-size: 50px;
  }

  &__title {
    font-size: typography.$h5-font-size;
    line-height: typography.$h5-line-height;
    font-weight: typography.$font-weight-bold;
  }

  &__message {
    font-size: typography.$base-font-size;
    line-height: typography.$base-line-height;
    font-weight: typography.$font-weight-medium;
  }

  &__title,
  &__message {
    margin: 0;

    text-align: center;
  }
}
</style>